export default __webpack_public_path__ + "static/media/Fundamentals of Digital marketing.f874f358.png";